import { storeNameSpace } from './import.modules';
import { storeModule } from './store.constants';

// 1. You should add to const first
// 2. Add your module here
export const storeModules = {
  [storeModule.localization]: storeNameSpace.localizationModule,
};
